/**
 * Tabs Module
 * Handles tabbed interfaces (How It Works, FAQ)
 */

export function initTabs() {
  // How It Works tabs
  initTabGroup('[data-tab]', '[data-panel]', 'how-it-works__tab--active', 'how-it-works__panel--hidden');

  // FAQ tabs
  initTabGroup('[data-faq-tab]', '[data-faq-panel]', 'faq-section__tab--active', 'faq-section__panel--hidden');
}

function initTabGroup(tabSelector, panelSelector, activeClass, hiddenClass) {
  const tabs = document.querySelectorAll(tabSelector);
  const panels = document.querySelectorAll(panelSelector);

  if (!tabs.length || !panels.length) return;

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const targetId = tab.getAttribute(tabSelector.replace('[', '').replace(']', ''));

      // Update tabs
      tabs.forEach(t => {
        const isActive = t === tab;
        t.classList.toggle(activeClass, isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      // Update panels
      panels.forEach(panel => {
        const panelId = panel.getAttribute(panelSelector.replace('[', '').replace(']', ''));
        const isActive = panelId === targetId;

        panel.classList.toggle(hiddenClass, !isActive);

        if (isActive) {
          panel.removeAttribute('hidden');
          // Open first accordion item in the new panel
          const firstAccordion = panel.querySelector('.accordion-item');
          if (firstAccordion && !firstAccordion.classList.contains('accordion-item--open')) {
            const toggle = firstAccordion.querySelector('[data-accordion-toggle]');
            toggle?.click();
          }
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    });

    // Keyboard navigation
    tab.addEventListener('keydown', (e) => {
      const tabList = Array.from(tabs);
      const currentIndex = tabList.indexOf(tab);
      let newIndex;

      if (e.key === 'ArrowRight') {
        newIndex = (currentIndex + 1) % tabList.length;
      } else if (e.key === 'ArrowLeft') {
        newIndex = (currentIndex - 1 + tabList.length) % tabList.length;
      } else if (e.key === 'Home') {
        newIndex = 0;
      } else if (e.key === 'End') {
        newIndex = tabList.length - 1;
      }

      if (newIndex !== undefined) {
        e.preventDefault();
        tabList[newIndex].focus();
        tabList[newIndex].click();
      }
    });
  });
}
